import { LOCATION_CHANGE } from '../constants/locationConstants.js';

const getInitialState = {
    hash: '',
    history: {},
};

export default (state = getInitialState, action) => {
    switch (action.type) {
        case LOCATION_CHANGE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
